import { ButtonColumn } from "./enums/buttoncolumn";
import { Claims } from "./index";

export class CommandBarButton {
    text: string;
    title: string;
    cssClass?: string;
    result: string;
    hideOnMobile?: boolean;
    hide?: boolean;
    column?: ButtonColumn;
    requiresClaim?: Claims;
    enabled?: boolean;
    classes?: string[];
    callbackFunction: Function;
}
